// extracted by mini-css-extract-plugin
module.exports = {"drawerRoot":"main_drawerRoot__lBeh8","fieldset":"main_fieldset__k6YxJ","legend":"main_legend__2XaXo"};